import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'

export const authGuard: CanActivateFn = (route, state) => {
  let authService = inject(AuthService)

  if (authService.isLoggedIn()) {
    return true
  }

  let router = inject(Router)
  router.navigate(['auth', 'login'])
  return false
}
